import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StyledHeader, StyledLogo } from "./styled";
import LanguageSwitcher from "../language_switcher/LanguageSwitcher";
var AppHeader = function () {
    return _jsxs(StyledHeader, { children: [_jsx("div", { children: _jsx(StyledLogo, { to: 'https://uae.sahl.tax', target: "_blank", children: "SAHL.TAX" }) }), _jsx("div", {}), " ", _jsx(LanguageSwitcher, {})] });
};
export default AppHeader;
